import { req, withParams } from 'vuelidate/lib/validators/common'

export default (lte) =>
  withParams({ type: 'lessEqual', lte }, (value) => {
    return !req(value) || Number(value) <= Number(typeof lte === 'function' ? lte() : lte)
  })
